<template>
  <div class="tourist-serve">
    <Title :title="serveTitle" :english-title="serveEnglishTitle"></Title>
    <RecommendServe
      class="section-content"
      type="card"
      :serve-url="serveUrl"
      :request="request"
      open-api
    ></RecommendServe>
    <SeeMore :next="serveNext" :name="name"></SeeMore>
  </div>
</template>
<script>
import Title from "../components/Title";
import SeeMore from "../components/SeeMore";
import { mapGetters } from "vuex";

export default {
  name: "RecServe",
  data() {
    return {
      serveTitle: "推荐服务",
      serveEnglishTitle: "recommendation service",
      serveNext: { next: "ServiceCenter" },
      name:'全部服务'
    };
  },
  components: {
    Title,
    SeeMore
  },
  computed: {
    ...mapGetters(["serveUrl", "request"])
  }
};
</script>
<style lang="scss">
  .tourist-serve {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    overflow: hidden;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgba(255, 255, 255, 1) 100%
    );

    .recommend-serve {
      flex: 1;
    }

    .components-title {
      padding-top: 90px;
      padding-bottom: 50px;
    }

    .RecommendServe-floatCard .mini_app {
      margin-bottom: 15px;
    }

    .see-more {
      margin-top: 40px;
      margin-bottom: 50px;
    }
  }
</style>
